import { render, staticRenderFns } from "./TurnoversTable.vue?vue&type=template&id=0565c456&"
import script from "./TurnoversTable.vue?vue&type=script&lang=ts&"
export * from "./TurnoversTable.vue?vue&type=script&lang=ts&"
import style0 from "./TurnoversTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
